import {checkInput, extractPlaceHolders, replacePlaceHolders} from "./templateEngineUtils";

export const applyTemplate = (template, data) => {
    if (checkInput(template, data)) return template
    const placeHolders = extractPlaceHolders(template);
    return replacePlaceHolders(template, data, placeHolders);
}